import React, { useEffect } from 'react';
import { useTranslation } from '../components/TranslationContext';
import { Helmet } from 'react-helmet';
import '../styles/values.css';
import '../styles/root.css';
import valuesImage1 from '../assets/64.jpg';
import valuesImage2 from '../assets/usine/Marine & Moi-118.jpg';
import valuesImage3 from '../assets/dons.jpg';
import valuesImage4 from '../assets/usine/Marine & Moi-84.jpg';

const Values = () => {
  const { translate } = useTranslation();
  const values = translate('values');

  useEffect(() => {
    const valueSections = document.querySelectorAll('.value-section');

    const checkVisibility = () => {
      valueSections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        if (rect.top <= windowHeight * 0.7 && rect.bottom >= 0) {
          section.classList.add('visible');
        } else {
          section.classList.remove('visible');
        }
      });
    };

    checkVisibility();
    window.addEventListener('scroll', checkVisibility);

    return () => {
      window.removeEventListener('scroll', checkVisibility);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Marine & Moi - Valeurs & Missions</title>
        <meta name="description" content="Découvrez les valeurs et missions de Marine & Moi, votre partenaire de confiance dans le textile premium." />
        <meta name="keywords" content="valeurs, missions, textile, premium, partenaire, confiance" />
      </Helmet>
      <div className="values-container">
        <div className="value-section">
          <div className="value-image">
            <img src={valuesImage1} alt="Repas quotidien" />
          </div>
          <div className="value-content">
            <div className="value-number">{values.wellbeingNumber}</div>
            <h2 className="value-title">{values.wellbeingTitle}</h2>
            <p className="value-description">{values.wellbeingDescription}</p>
          </div>
        </div>
        <div className="value-section">
          <div className="value-image">
            <img src={valuesImage2} alt="Accès aux soins" />
          </div>
          <div className="value-content">
            <div className="value-number">{values.healthNumber}</div>
            <h2 className="value-title">{values.healthTitle}</h2>
            <p className="value-description">{values.healthDescription}</p>
          </div>
        </div>
        <div className="value-section">
          <div className="value-image">
            <img src={valuesImage3} alt="Dons ponctuels" />
          </div>
          <div className="value-content">
            <div className="value-number">{values.supportNumber}</div>
            <h2 className="value-title">{values.supportTitle}</h2>
            <p className="value-description">{values.supportDescription}</p>
          </div>
        </div>
        <div className="value-section">
          <div className="value-image">
            <img src={valuesImage4} alt="Formations" />
          </div>
          <div className="value-content">
            <div className="value-number">{values.developmentNumber}</div>
            <h2 className="value-title">{values.developmentTitle}</h2>
            <p className="value-description">{values.developmentDescription}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Values;
